module.exports = __webpack_public_path__ + "static/media/chat-onboarding_02.779fc596.png";